import __request__ from "routing/request";
export function entries(page = 1, per_page = 50, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.auditlog/entries", null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function search(query, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.auditlog/entries", query, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportCsv(query, limit, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.auditlog/entries/export/csv", null, { "query": query, "limit": limit }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function exportJson(query, limit, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.auditlog/entries/export/json", null, { "query": query, "limit": limit }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
